export default __webpack_public_path__ + "static/media/stripe_logo.04460ef6.svg";